import React, { useContext, useEffect } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "../..";
import api from "~/services/api";
import { toast } from "react-toastify";

export default function FinancialDRERegister() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "dre_name", asc: true };
  const defaultGridHeader = [
    {
      title: "DRE Name",
      name: "dre_name",
      type: "text",
      filter: true,
    },
    {
      title: "DRE Code",
      name: "dre_code",
      type: "text",
      filter: false,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
  ];

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);
  
  const pageAccess = { view: true, edit: true, create: true, inactivate: false };

  useEffect(() => {
    setActiveFilters([]);
  }, []);
  
  async function loader() {
    setLoadingData(true);
    
    try {
      const { data } = await api.get('/dreconfigs-getall');
      
      const gridDataValues = data.map(({ id, dre_name, dre_code, status }, index) => ({
        show: true,
        id,
        fields: [dre_name, dre_code, status],
        page: Math.ceil((index + 1) / limit),
      }));
      
      setPages(Math.ceil(data.length / limit));
      setGridDetails({ totalRows: data.length, pages: Math.ceil(data.length / limit) });
      setGridData(gridDataValues);
    } catch (err) {
      console.error('Error loading DRE configs:', err);
      toast.error('Error loading DRE configurations');
    } finally {
      setLoadingData(false);
    }
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
      newButtonNearSearch={true}
    />
  );
}